import React, { useContext } from 'react'
import { Switch, Route, useHistory } from "react-router-dom";
import { routes } from './';
import { GlobalContext, GlobalContextI } from "global-context";

function ProtectedRoute(props:any) {
  const globalContext: GlobalContextI = useContext(GlobalContext);
  const history = useHistory();

  if(!globalContext.user.token) {
    history.push('/login')
  }

  if(globalContext.loading) {
    return <>Loading</>
  }

  return <Route {...props} />
}

export const Router = () => (
  <Switch>{routes.map( (route) => route.protected
    ? <ProtectedRoute path={route.path} component={route.component} exact />
    : <Route path={route.path} component={route.component} exact />)}
  </Switch>
)
